import ContentModel from '../../models/ContentModel';
import GameModel from '../../models/Model';
import { PopupModel, QuestionModel, QuestionModelFilter } from '../../interfaces/IContentModel';
import SaveModel from '../../models/SaveModel';
import { shuffleArrayFY } from '../utils/Utils';

/**
 * A Plugin that handles common data persistance for projects.
 * these are automatically loaded from json files and typed.
 * @category plugins
 * @export
 * @class DataPlugin
 * @extends {Phaser.Plugins.BasePlugin}
 */
export default class DataPlugin extends Phaser.Plugins.BasePlugin {
  /**
   * @constructor Creates an instance of GameData plugin (that handles any extra data based functionallity).
   * @param {Phaser.Plugins.PluginManager} pluginManager
   * @memberof GameData
   */
  constructor(pluginManager: Phaser.Plugins.PluginManager) {
    super(pluginManager);
    console.log("GameData::constructor");

  }

  loadContentForLanguage(jsonCacheIdentifier: string): void {

    console.log(`Loading language content of ID: ${jsonCacheIdentifier}`);

    const langContent = this.game.cache.json.get(jsonCacheIdentifier);
    if (langContent !== undefined) {
      Object.assign(this.model.content, langContent);
    } else {
      console.warn("Error loading language content");
    }
    // add index to our question model array.
    this.model.content.questions.forEach((item, index) => {
      item.i = index;
    });

  }

  prepareDataModel(): void {
    this.loadContentForLanguage("content");


    //generate all possible voiceOver text and keys

    const voiceOvers = [];

    for(const glossaryItem of this.model.content.glossery){

      voiceOvers.push({
        reference:`glossary-${glossaryItem.word.replace(" ","-").toLocaleLowerCase()}`,
        text: `${glossaryItem.word} - ${glossaryItem.description}`
      })

    }


    for(const popupID in this.model.content.popups){
      const popup = this.model.content.popups[popupID];

      let pageIndex = -1;
      for(const page of popup.pages){

        pageIndex ++;

        voiceOvers.push({
          reference: popupID + "-" +pageIndex,
          text: page.title + " - " +  page.body.replace(/<[^>]*>/g, ' ')
        })

        for(const glossaryItem of this.model.content.glossery){

          // voiceOvers.push({
          //   reference:`glossary-${glossaryItem.word.replace(" ","-").toLocaleLowerCase()}`,
          //   text: `${glossaryItem.word} - ${glossaryItem.description}`
          // })

          // if(page.body.indexOf(glossaryItem.word) > -1){
          //   console.log(glossaryItem, page.body);
          // }
          page.body = page.body.replace(glossaryItem.word, `<span class='glossery'><span data-vo='${glossaryItem._voiceOver?glossaryItem._voiceOver:""}' class='glossary-word'>${glossaryItem.word}</span><span class='description'><span class='title'>${glossaryItem.word}</span><br>${glossaryItem.description}</span><span class='description-close'>x</span></span>`)
        }

      }
    }

    for(const bankID in [this.model.content.mainQuestionsEasy,this.model.content.mainQuestionsMedium, this.model.content.mainQuestionsHard]){

    const bank = [this.model.content.mainQuestionsEasy,this.model.content.mainQuestionsMedium, this.model.content.mainQuestionsHard][bankID];

    const difficulty = ["easy", "medium", "hard"][bankID];

    for(const questionID in bank){
      voiceOvers.push({
        reference:`question-${difficulty}-${questionID}-body`,
        text: bank[questionID].question.replace(/<[^>]*>/g, ' ')
      })


      //answers are just YES / NO.
      // for(const answer in bank[questionID].answers){
      //   voiceOvers.push({
      //     reference:`question-${difficulty}-${questionID}-answer-${answer}`,
      //     body: bank[questionID].answers[answer].text.replace(/<[^>]*>/g, ' ')
      //   })
      // }
    }


  }

  for(const stringReference in this.model.content.strings){
    voiceOvers.push({
      reference:`string-${stringReference}`,
      text: this.model.content.strings[stringReference]
    })
  }


    console.log(JSON.stringify(voiceOvers,null,2));

  }

  /**
   * get a unique bank of items from an array defined in the Content model,
   * this will be recorded and future banks will omit the ones being returned.
   * Used in conjunction with `resetBankOfItems` to reset the history of the supplied items.
   *
   * @param {number} amountToGenerate the number of items to return.
   * @param {{key: string, value: any}[]} [filter] an object of key values pairs to filter the array by, currently only an `===` comparison is used.
   * @returns {any[]} an array of request length of unique items from idendtifier supplied
   * @memberof DataPlugin
   */
  generateBankOfQuestions(amountToGenerate: number, filter?: QuestionModelFilter): QuestionModel[] | undefined {

    // get array of all questions

    let allItems: any[] = this.model.content.questions;

    const _f: {
      [key: string]: number | string;
     } = filter as {
      [key: string]: number | string;
     };

    if (filter) {
      // we have a filter we wish to apply
      for (const key in filter) {

        
        const value = _f[key];

        // filter the current data set to remove any that do not satisfy our filter conditions.
        allItems = allItems.filter((item) => {
          if (item[key]) {
            if (item[key] === value) {
              return true;
            }
          }
          return false;
        });

      }

    }

    let selected: QuestionModel[] = [];

    // reduce the array with the history log
    if (this.bankHistoryLookupIndex.length > 0) {
      // we have some previous banks generated for this category

      // enough items?
      if (this.bankHistoryLookupIndex.length + amountToGenerate > allItems.length) {
        console.warn(`Not enough items left in question bank to select ${amountToGenerate}`);
        return;
      }

      // reduce all iitems by the index's stored in our history array
      selected = allItems.filter((item) => {
        return (this.bankHistoryLookupIndex.indexOf(item.i) < 0);
      });

    } else {
      selected = allItems;
    }

    // shuffle the avlible items (fisher-Yates seems to be the standard used.)
    const shuffled = shuffleArrayFY(selected) as QuestionModel[];


    // truncate to the amound requied.
    shuffled.length = amountToGenerate;

    // pop into our histroy array.

    // concat the current history with that of the chooen questions
    this.bankHistoryLookupIndex = this.bankHistoryLookupIndex.concat(shuffled.map((item: any) => {
      return item.i;
    }));


    return shuffled;
  }


  /**
   * reset the history of banked items requested for a certain identifier, to be used in conjunction with `generateBankOfItems`
   *
   * @param {string} topLevelIdentifier this name of the array as dewfined in the top level of the `ContentModel`
   * @returns
   * @memberof DataPlugin
   */
  resetBankOfItems(topLevelIdentifier: string): void {
    try {
      this.bankHistoryLookupIndex.length = 0;
    } catch (e) {
      console.warn(`Error removing history for item banking from:${topLevelIdentifier} `, e);
      return;

    }
  }

  /**
   * internal store for previously used banked questions.
   *
   * @private
   * @type {{[key: string]: number[]}}
   * @memberof DataPlugin
   */
  private bankHistoryLookupIndex: number[] = [];

  /**
   * our main model refence
   *
   * @type {GameModel}
   * @memberof DataPlugin
   */
  public model: GameModel = new GameModel();

  /**
   * get the current save model value
   *
   * @type {SaveDataModel}
   * @memberof GameData
   */
  get save(): SaveModel {
    return this.model.save;
  }

  /**
 * set the save model value and persist data if required.
 *
 * @memberof GameData
 */
  set save(newSave: SaveModel) {
    // assign the save model
    this.model.save = newSave;
  }

  /**
   * the entire content model
   *
   * @readonly
   * @type {ContentModel}
   * @memberof DataPlugin
   */
  get content(): ContentModel {
    return this.model.content;
  }





  /**
   * any initilise function
   *
   * @memberof GameData
   */
  public init(): void {
    console.log("GameData::init");
  }

  /**
 * get popup model of specific ID.
 *
 * @param {string} id
 * @returns {string}
 * @memberof ContentModel
 */
  public getPopup(id: string): PopupModel | undefined {
    let popup: PopupModel;
    try {
      popup = (this.content.popups[id] as PopupModel);
    } catch (e) {
      return;
    }

    return popup;


  }
}


